import script from "./SkillManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillManagement.vue?vue&type=script&setup=true&lang=js"

import "./SkillManagement.vue?vue&type=style&index=0&id=5c5eb46e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c5eb46e"]])

export default __exports__